import constants, { ACCESS_TOKEN, HTTP_METHODS } from "../../../settings/shared/constants";
import axiosClient from "../../common";

function _constructHeader() {
    const jwtToken = localStorage.getItem(ACCESS_TOKEN);

    return {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${jwtToken}`
    };
}

function createStack(payload) {
    return axiosClient({
        url: constants.api.stack.create,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: payload
    });
}

function getAllStacks() {
    return axiosClient({
        url: constants.api.stack.getAll,
        method: HTTP_METHODS.GET,
        headers: _constructHeader()
    });
}

function getStackById(id) {
    return axiosClient({
        url: constants.api.stack.getById + id,
        method: HTTP_METHODS.GET,
        headers: _constructHeader()
    });
}

const StackService = { createStack, getAllStacks, getStackById };

export default StackService;